<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
<template>
  <v-content> 
    <Hero/>
    <NewsSection/>
    <Info/>
    <DeviceStatus/>
  </v-content>
</template>

<script>

import Hero from "../components/home/Hero.vue";
import NewsSection from "../components/home/NewsSection.vue";
import Info from "../components/home/Info.vue";
import DeviceStatus from "../components/home/DeviceStatus.vue";
export default {
  name: "Homesite",
  components: {
    Hero, 
    NewsSection,
    Info,
    DeviceStatus
  },
};
</script>